<template>
	<div class="container h-100 box page-wrapper">
		<h3 v-if="verified==false">Confirming...</h3>
		<div v-if="verified==true">
			<h3 v-if="item!=false">{{title}}</h3>
			<p>{{message}}</p>
			<div v-if="item!=false">
				<p>Your booking detail</p>
				<p>Date: {{item.bookingDate}}</p>
				<p>Time: {{item.bookingTime}}</p>
				<p>Number of people: {{item.headCount}}</p>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios';

export default {
	name: 'confirm',
	data() {
		return {
			title:'',
			message:'',
			item:false,
			verified:false,
		}
	},
	mounted: function(){
		   	console.log(this.$route.query.email);
	    	var id = this.$route.query.id;
	    	var hash = this.$route.query.hash;
	    	var sheet = this.$route.query.sheet;
	    	var state = this.$route.query.state;
	    	var url = process.env.ROOT_API + "?type=adminConfirm&sheet=" + sheet + "&id=" + id + "&hash=" + hash + "&state=" + state;

	    	console.log("URL:" + url);
	    	var self = this;
	    	axios.get(url)
	    	.then(response=>{
	    		console.log(response);
	    		var data = response.data;
	    		self.$data.message = data.message;
	    		self.$data.title = data.title;
	    		if(data.result==true) {
	    			self.$data.item = data.item;
	    		}
	    		self.$data.verified = true;
	    	})
	    	.catch(error=>{
	    		self.$data.message = error;
	    		self.$data.verified = true;
	    	})

    }
}
</script>



// WEBPACK FOOTER //
// src/components/AdminConfirm.vue